import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

type FramedImageProps = {
  imgSrc: string;
  alt: string;
};

const FramedImage: FunctionComponent<FramedImageProps> = (props) => {
  return (
    <S.Container>
      <S.ImageContainer>
        <Image
          src={props.imgSrc}
          alt={props.alt}
          layout="fill"
          objectFit="cover"
        />
      </S.ImageContainer>
    </S.Container>
  );
};

export default FramedImage;

const S = () => {};

S.Container = styled.div`
  background: white;
  width: 100%;
  aspect-ratio: 1;

  @supports not (aspect-ratio: 1) {
    &::before {
      float: left;
      padding-top: 100%;
      content: "";
    }

    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  height: 70%;
  width: 70%;
  margin: auto;
  transform: translateY(22%);
`;
